module.exports = __webpack_public_path__ + "static/media/teamOne.56e61dd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/team/teamOne.jpg
// module id = 96
// module chunks = 0